// @flow
const ROOT: string = '@@app'
export const SET_PRODUCT_LANGUAGE: string = `${ROOT}/SET_PRODUCT_LANGUAGE`
export const SET_PRODUCT_FORMATS: string = `${ROOT}/SET_PRODUCT_FORMATS`
export const SET_RELATED_PRODUCT_FORMAT_IN_CART: string = `${ROOT}/SET_RELATED_PRODUCT_FORMAT_IN_CART`

export const setProductLanguage = (productLanguage: string) => ({
  type: SET_PRODUCT_LANGUAGE,
  productLanguage
})

export const setProductFormats = (productFormats: Array<Object>) => ({
  type: SET_PRODUCT_FORMATS,
  productFormats
})

export const setRelatedProductFormatInCart = (
  relatedProductFormatInCart: Object
) => ({
  type: SET_RELATED_PRODUCT_FORMAT_IN_CART,
  relatedProductFormatInCart
})
